module.exports = __webpack_public_path__ + "static/img/how-to-join-title.295d417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/how-to-join-title.png
// module id = iScI
// module chunks = 1